module.exports = __webpack_public_path__ + "static/img/sdk.1fa0ec0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sdk.jpg
// module id = l4hI
// module chunks = 1